export default __webpack_public_path__ + "static/media/Coca-Cola.29eba13a.svg";